import { Box, Typography } from "@mui/material";
import { TableColumn } from "@vilocnv/allsetra-core";

/**
 * STATIONARY REPORT
 */
export const STATIONARY_NAME_RENDERING = (
  translator: any
): TableColumn<any>[] => [
  {
    name: translator("tableHeading.startTime", {
      ns: "tableHeadingsTranslation"
    }),
    cell: (row: any) => {
      return (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          py={1}
        >
          <Typography variant="subtitle2" fontWeight={600}>
            {row.name || "N/A"}
          </Typography>
        </Box>
      );
    }
  },
  {
    name: translator("tableHeading.endTime", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.duration", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.location", {
      ns: "tableHeadingsTranslation"
    }),
    cell: (row: any) => {
      const total = (row.records || []).reduce(
        (acc: number, r: any) => acc + (r.count || 0),
        0
      );
      return (
        <Box display="flex" justifyContent="flex-end" width="100%">
          <Typography variant="subtitle2" color="primary" fontWeight={600}>
            {total} {translator("reports.rides")}
          </Typography>
        </Box>
      );
    }
  }
];

export const STATIONARY_DATE_RENDERING = (
  translator: any
): TableColumn<any>[] => [
  {
    name: translator("tableHeading.startTime", {
      ns: "tableHeadingsTranslation"
    }),
    cell: (row: any) => {
      return (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          py={1}
        >
          <Typography variant="subtitle2" fontWeight={600}>
            {row.label}
          </Typography>
        </Box>
      );
    }
  },
  {
    name: translator("tableHeading.endTime", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.duration", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.location", {
      ns: "tableHeadingsTranslation"
    }),
    cell: (row: any) => {
      return (
        <Box display="flex" justifyContent="flex-end" width="100%">
          <Typography variant="subtitle2" color="primary" fontWeight={600}>
            {row.count} {translator("reports.rides")}
          </Typography>
        </Box>
      );
    }
  }
];

export const STATIONARY_INNER_TABLE_COLUMNS = (
  translator: any
): TableColumn<any>[] => [
  {
    cell: (row: any) => {
      if (!row?.start) return "N/A";
      const date = new Date(row.start);
      return date.toLocaleTimeString("nl-NL", {
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    wrap: true,
    sortable: true
  },
  {
    cell: (row: any) => {
      if (!row?.end) return "N/A";
      const date = new Date(row.end);
      return date.toLocaleTimeString("nl-NL", {
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    sortable: true
  },
  {
    cell: (row: any) => {
      return row.duration || "N/A";
    },
    sortable: true
  },
  {
    cell: (row: any) => {
      return row.startAddress || "N/A";
    },
    sortable: true,
    wrap: true
  }
];
